import { createContext, useContext } from "react";

import type { KanbanContextValue } from "./types-kanban";

export const KanbanContext = createContext<KanbanContextValue | null>(null);

export function useKanbanContext(): KanbanContextValue {
  const context = useContext(KanbanContext);
  if (!context) throw new Error("Kanban.* deve ser usado dentro de Kanban.Board");
  return context;
}
